import { render, staticRenderFns } from "./SingleInput.vue?vue&type=template&id=38f448f0&scoped=true"
import script from "./SingleInput.vue?vue&type=script&lang=js"
export * from "./SingleInput.vue?vue&type=script&lang=js"
import style0 from "./SingleInput.vue?vue&type=style&index=0&id=38f448f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f448f0",
  null
  
)

export default component.exports